<template>
	<div class="k-text-area" :class="{'k-text-area__errors-wrapper': errorMessage}">
		<div v-if="separateLabel && !hideLabel" class="k-text-area__label vitae-default-color">{{ separateLabel }}</div>
		<v-textarea
			v-model="value"
			:label="label"
			:error-messages="errorMessage"
			:disabled="disabled"
			:placeholder="placeholder"
			:name="name"
			outlined
			hide-details
			:variant="variant"
		/>
		<div class="k-text-area__errors">{{ errorMessage }}</div>
	</div>
</template>

<script setup lang="ts">
import { computed, defineEmits, defineProps, toRef, withDefaults } from 'vue';
import { useField } from 'vee-validate';
interface IOwnProps {
	modelValue?: string | null
	label?: string
	name?: string
	placeholder?: string
	disabled?: boolean
	variant?: 'filled' | 'outlined' | 'plain' | 'underlined' | 'solo' | 'solo-inverted' | 'solo-filled' | undefined
	separateLabel?: string
	hideLabel?: boolean
	validateOnValueUpdate?: boolean
}
interface IProps extends IOwnProps {
}

const props = withDefaults(defineProps<IProps>(), {
	variant: 'outlined',
});
const emit = defineEmits(['update:modelValue']);

const { value: fieldValue, errorMessage } = useField(toRef(props, 'name'), undefined, {
	initialValue: props.modelValue,
	validateOnValueUpdate: props.validateOnValueUpdate,
});
const value = computed({
	get() {
		return props.modelValue;
	},
	set(newValue) {
		fieldValue.value = newValue;
		emit('update:modelValue', newValue);
	}
});

</script>

<style scoped lang="scss">
.k-text-area {
	&__label {
		font-weight: 700;
		font-size: 14px;
	}

	&__errors {
		font-size: 12px;
		color: $red-400;
		text-transform: lowercase;
		margin-top: 10px;

		&::first-letter {
			text-transform: uppercase;
		}
	}

	&:deep(.v-textarea .v-field__input) {
		padding: 8px;
		mask-image: none;
		font-family: $poppins-font-family;
		font-weight: 300;
		font-size: 14px;
		color: $black;
		background-color: transparent;
	}

	&:deep(.v-field--variant-outlined .v-field__outline__end) {
		border: none;
	}

	&:deep(.v-field--variant-outlined .v-field__outline__start) {
		border: none;
	}

	&__errors-wrapper {
		&:deep(.v-field--variant-outlined .v-field__outline__end) {
			border-top: 1px solid $red-400;
			border-right: 1px solid $red-400;
			border-bottom: 1px solid $red-400;
		}

		&:deep(.v-field--variant-outlined .v-field__outline__start) {
			border-top: 1px solid $red-400;
			border-left: 1px solid $red-400;
			border-bottom: 1px solid $red-400;
		}
	}
}
</style>
